/**
 * @file sidebar-context.js
 * @description Contexto da sidebar (CRA)
 */

import { createContext } from "react"

/**
 * Contexto da sidebar
 */
export const SidebarContext = createContext(undefined)
